import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../app.component';
import {UserMin} from "../Models/UserMin";
import {TableBoName} from "../enums/table-bo-name.enum";

@Component({
	selector: 'app-agents',
	templateUrl: './agents.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./agents.component.less']
})

export class AgentsComponent implements OnInit {
	globalTxt: any;
	modalsTxt: any;
	textes: any;
	agents: UserMin[] = []
	originalAgents: UserMin[] = [];
	searchTerm: string = '';
	tabOptions: any = this.app.sharedToolsService.initTabOptions(TableBoName.USERS);
	userId: any = localStorage.getItem('user_id');

	//userRole: any = localStorage.getItem('user_role');

	constructor(
		public app: AppComponent,
	) {
	}

	ngOnInit(): void {
		if (!this.app.sharedToolsService.getIfSessionExists()) {
			this.app.router.navigate(['/']);
			return;
		}

		// Remove the modalOpen from localStorage to avoid problems
		localStorage.removeItem("modalOpen");

		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
	}

	getInfosInit(_nameJson: any) {
		// Get the settings
		this.app.sharedToolsService.getSettings();

		// Get the agents
		this.getAllUsersAltByUsrId(this.userId, this.app.type_agent_id);

		this.app.sharedToolsService.loadTexts(_nameJson)
			.subscribe(textes => {
				this.textes = textes;

				// Get the global texts
				this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
					this.globalTxt = globalTxt;

					// Get the modal texts
					this.app.dataInitService.getModalTextsOnce(modalsTxt => {
						this.modalsTxt = modalsTxt;
					});

					// Set the pagination labels
					this.app.previousLabelTxt = this.app.sharedToolsService.getPaginationLabels('prev');
					this.app.nextLabelTxt = this.app.sharedToolsService.getPaginationLabels('next');
				})
			})
	}

	getAllUsersAltByUsrId(_userId: number, _typeId: number) {
		console.log("getAllUsersAltByUsrId _userId _typeId ==> ", _userId, _typeId);
		this.app.apiToolsService.getAllUsersAltByUsrId(_userId, _typeId).subscribe((agents: any) => {
			console.log("getAllUsersAltByUsrId ==> ", agents);
			this.agents = agents;
			this.originalAgents = agents;

			this.app.sharedToolsService.sortTable(this.tabOptions.sortKey, this.agents, this.tabOptions);
		});
	}

	search() {
		if (this.searchTerm) {
			this.agents = this.app.sharedToolsService.searchInTable(this.searchTerm, this.originalAgents, [], this.textes.blocTable.cols);
		} else {
			this.agents = [...this.originalAgents];
		}
		this.tabOptions = this.app.sharedToolsService.initTabOptions(TableBoName.USERS);
	}
}
